import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const createDomain = payload =>
  api.post(`/platform/company?accountId=${payload.accountId}`, payload.data)

const getDNS = payload => api.get(`/platform/company/dns/record`, payload)

const getCompanyData = payload => api.get('/platform/admin/company/manage', payload)

const createCompany = payload =>
  api.post(`/platform/admin/company`, payload.data, { params: payload.params })

const editCompany = payload =>
  api.put(`/platform/admin/company/edit`, payload.data, { params: payload.params })

const deleteCompany = payload =>
  api.delete(`/platform/admin/company/manage/${payload.companyId}`, { params: payload.params })

export default {
  createDomain,
  getDNS,
  getCompanyData,
  createCompany,
  editCompany,
  deleteCompany
}
